import {
  BulkResendEsignatureSignatureDocument,
  BulkResendEsignatureSignatureMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkResendRequestSignature = () => {
  const [bulkResendEsignatureSignature, { loading }] = useMutation(
    BulkResendEsignatureSignatureDocument,
    {
      extractorFn: (data) => data.esignatureMutations.bulkResendSignatureEsignatureSignature,
    }
  )

  return {
    loading,
    bulkResendRequestSignature(variables: BulkResendEsignatureSignatureMutationVariables) {
      return bulkResendEsignatureSignature({
        variables,
      })
    },
  }
}
